<template>
    <div class="overlayed-image" :style="{height, width, backgroundImage: `url(${src})`, backgroundSize}">

        <div class="overlayed-image-overlay"></div>

    </div>
</template>

<script>
    export default {
        props: {
            src: String,
            height: String,
            width: String,
            backgroundSize: String
        }
    }
</script>

<style lang="scss">
    .overlayed-image{
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        
        > .overlayed-image-overlay{
            height: 100%;
            width: 100%;
            background-color: rgba(255,255,255,0);
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/OverlayedImage.vue